import styled from 'styled-components';

export const CardSection = styled.div`
  display: flex;
  // using margin instead of padding so the margins can collapse when there are 2 next to each other
  margin: 24px;
  gap: 8px;
  flex-direction: column;
`;

export const CustomHairline = styled.div`
  background-color: var(--grayscale-50);
  margin: 0 24px;
  width: auto;
  height: 1px;
`;

export const RedraftBanner = styled.div`
  background-color: var(--surface-200);
  padding: 12px;
  border-radius: var(--border-radius-medium);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

// TODO: consolidate this with the other value prop banners and info boxes
export const ValuePropBanner = styled.div`
  background-color: var(--purple-200);
  // border for windows high contrast mode, which removes background colors but changes all borders to 100% opacity black
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 12px;
  border-radius: var(--border-radius-medium);
  margin-bottom: 24px;
`;
